export function extractTableFromUrl(loc: Location): number | null {
  const search = new URLSearchParams(loc.search);
  const queryVal = search.get("table") ?? search.get("t");
  if (queryVal && isFinite(+queryVal) && +queryVal > 0) {
    return Math.floor(+queryVal);
  }

  if (loc.hash) {
    const hash = loc.hash.split("?")[1];
    if (hash) {
      const hashParams = new URLSearchParams(hash);
      const hv = hashParams.get("table") ?? hashParams.get("t");
      if (hv && isFinite(+hv) && +hv > 0) {
        return Math.floor(+hv);
      }
    }
  }

  const path = loc.pathname.toLowerCase();
  const m = path.match(/\/(table|t)\/(\d+)/);
  if (m && isFinite(+m[2]) && +m[2] > 0) {
    return Math.floor(+m[2]);
  }

  return null;
}

export function cleanUrlRemovingTableParam() {
  try {
    const url = new URL(window.location.href);

    url.searchParams.delete("table");
    url.searchParams.delete("t");

    if (url.hash.includes("?")) {
      const [hashPath, hashQuery] = url.hash.split("?");
      const hp = new URLSearchParams(hashQuery);
      hp.delete("table");
      hp.delete("t");
      url.hash = hp.toString() ? `${hashPath}?${hp.toString()}` : hashPath;
    }

    url.pathname = url.pathname.replace(/\/(table|t)\/\d+/, "");

    window.history.replaceState({}, "", url.toString());
  } catch {}
}
